<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="props.detailData.xftel + '-的所有续费名单'" :width="1400" :open="true" :confirmLoading="state.loading"
        :maskClosable="false" @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        "><a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="平台名称" name="platform_id">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.platform_id"
                                    placeholder="请选择平台">
                                    <a-select-option v-for="(item, index) in state.platformList" :key="index"
                                        :value="item.id">{{ item.platform_abbreviation }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="公司名称" name="nameOrCode">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.nameOrCode"
                                    placeholder="请输入公司名称、税号"> </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="代理商姓名" name="seller">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.seller" placeholder="请输入">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="法人代表姓名" name="fr_name">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.fr_name" placeholder="请输入">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <template v-if="state.advanced">
                            <a-col :md="6" :sm="24" v-if="user.username == 'wanduo' || user.username == 'admin'">
                                <a-form-item label="法人代表姓名" name="fr_name">
                                    <a-input @keyup.enter="loadData" v-model:value="queryParam.fr_name"
                                        placeholder="请输入"> </a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :md="6" :sm="24">
                                <a-form-item label="地址编号" name="address_number">
                                    <a-input @keyup.enter="loadData" v-model:value="queryParam.address_number"
                                        placeholder="请输入"> </a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :md="6" :sm="24">
                                <a-form-item label="入驻类型" name="business_type">
                                    <a-select allow-clear mode="multiple" v-model:value="queryParam.business_type"
                                        placeholder="请选择">
                                        <a-select-option :value="1">设立</a-select-option>
                                        <a-select-option :value="2">同区迁入</a-select-option>
                                        <a-select-option :value="3">跨区迁入</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </template>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="主体类型" name="main_type">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.main_type"
                                    placeholder="请选择">
                                    <a-select-option :value="1">公司</a-select-option>
                                    <a-select-option :value="2">个体</a-select-option>
                                    <a-select-option :value="3">个人独资</a-select-option>
                                    <a-select-option :value="4">合伙企业</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>

                        <a-col :md="6" :sm="24">
                            <a-form-item label="主体状态" name="exception_flag">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.exception_flag"
                                    placeholder="请选择">
                                    <a-select-option :value="1">正常状态</a-select-option>
                                    <a-select-option :value="2">待申报地址异常</a-select-option>
                                    <a-select-option :value="3">已办理地址异常手续</a-select-option>
                                    <a-select-option :value="4">确认地址已进入异常名单客户</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <!-- <a-col :md="6" :sm="24">
            <a-form-item label="录入系统时间" name="between_time">
              <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime" @change="rangTimeChange" :format="format"></a-range-picker>
            </a-form-item>
          </a-col> -->
                        <a-col :md="6" :sm="24">
                            <a-form-item label="到期时间" name="between_end">
                                <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangEnd"
                                    @change="rangEndChange" :format="format"></a-range-picker>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <div class="table-page-search-submitButtons" style="overflow: hidden; margin-bottom: 0">
                                <a-button type="primary" @click="loadData">查询</a-button>

                                <a @click="toggleAdvanced" style="margin-left: 8px">
                                    {{ state.advanced ? '收起' : '展开' }}
                                    <UpOutlined v-if="state.advanced" />
                                    <DownOutlined v-else />
                                </a>
                                <a-popover title="导出参数配置" trigger="click" :overlayStyle="{ width: '60%' }"
                                    placement="left" v-model:open="exportDataArgumentChecked.visible">
                                    <template #content>
                                        <a-tabs v-model:activeKey="exportDatatab">
                                            <a-tab-pane key="1" tab="根据搜索参数直接导出"><a-descriptions :column="1">
                                                    <a-descriptions-item label="导出版本"
                                                        :contentStyle="{ paddingTop: '10px' }"
                                                        :labelStyle="{ paddingTop: '10px' }">
                                                        <a-button
                                                            @click="selectExportDataArgument(1)">精简版</a-button><a-divider
                                                            type="vertical" /> <a-button
                                                            @click="selectExportDataArgument(2)">全能版</a-button><a-divider
                                                            type="vertical" />
                                                        <a-button @click="selectExportDataArgument(3)">取消选择</a-button>
                                                    </a-descriptions-item>
                                                    <a-descriptions-item label="导出字段">
                                                        <a-checkbox-group
                                                            v-model:value="exportDataArgumentChecked.checkedfieldSimple"
                                                            name="checkboxgroup"
                                                            :options="exportDataArgumentChecked.exportDataArgument" />
                                                    </a-descriptions-item>
                                                    <a-descriptions-item :contentStyle="{ paddingLeft: '62px' }">
                                                        <a-button style="margin-left: 8px; display: inline-flex"
                                                            :icon="h(SvgIcon, { name: 'excel' })"
                                                            @click="exportClick(1)"
                                                            :loading="state.exportLoading">导出</a-button>
                                                    </a-descriptions-item>
                                                </a-descriptions></a-tab-pane>
                                            <a-tab-pane key="2" tab="根据输入的公司名称导出详细信息（选择此项，搜索条件将失效）"><a-descriptions
                                                    :column="1">
                                                    <a-descriptions-item label="公司名称"
                                                        :contentStyle="{ paddingTop: '10px' }"
                                                        :labelStyle="{ paddingTop: '10px' }">
                                                        <a-textarea
                                                            v-model:value="exportDataArgumentChecked.companylist"
                                                            placeholder="请输入公司名称" allow-clear :rows="6" />
                                                    </a-descriptions-item>
                                                    <a-descriptions-item label="导出版本"
                                                        :contentStyle="{ paddingTop: '10px' }"
                                                        :labelStyle="{ paddingTop: '10px' }">
                                                        <a-button
                                                            @click="selectExportDataArgument(1)">精简版</a-button><a-divider
                                                            type="vertical" /> <a-button
                                                            @click="selectExportDataArgument(2)">全能版</a-button><a-divider
                                                            type="vertical" />
                                                        <a-button @click="selectExportDataArgument(3)">取消选择</a-button>
                                                    </a-descriptions-item>
                                                    <a-descriptions-item label="导出字段">
                                                        <a-checkbox-group
                                                            v-model:value="exportDataArgumentChecked.checkedfieldSimple"
                                                            name="checkboxgroup"
                                                            :options="exportDataArgumentChecked.exportDataArgument" />
                                                    </a-descriptions-item>
                                                    <a-descriptions-item :contentStyle="{ paddingLeft: '62px' }">
                                                        <a-button style="margin-left: 8px; display: inline-flex"
                                                            :icon="h(SvgIcon, { name: 'excel' })"
                                                            @click="exportClick(2)"
                                                            :loading="state.exportLoading">导出</a-button>
                                                    </a-descriptions-item>
                                                </a-descriptions>
                                            </a-tab-pane>
                                        </a-tabs>
                                    </template>
                                    <a-button style="margin-left: 8px; display: inline-flex"
                                        :icon="h(SvgIcon, { name: 'excel' })"
                                        :loading="state.exportLoading">导出</a-button>
                                </a-popover>
                            </div>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="false"
                rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'index'"> {{ index + 1 }} </template>
                    <template v-if="column.dataIndex === 'name'"> {{ text }} </template>
                    <template v-if="column.dataIndex === 'exception_flag'">
                        <a-tag color="green" v-if="record.exception_flag == 1">正常状态</a-tag>
                        <a-tag color="red" v-else-if="record.exception_flag == 2">待申报异常【代理商待确认①】</a-tag>
                        <a-tag color="red" v-else-if="record.exception_flag == 3">待申报异常【代理商已确认，公司待确认②】</a-tag>
                        <a-tag color="red" v-else-if="record.exception_flag == 4">待申报异常【代理商、公司已确认，准备提交资料③】</a-tag>
                        <a-tag color="red" v-else-if="record.exception_flag == 5">已申报异常【已交资料，待确认是否地址异常】</a-tag>
                        <a-tag color="red" v-else-if="record.exception_flag == 6">人工已确认地址已异常</a-tag>
                        <a-tag color="red" v-else>异常</a-tag>
                    </template>
                    <template v-if="column.dataIndex === 'enter_endtime'"> <span
                            v-html="record.enter_endtime2"></span></template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, h } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
import SvgIcon from '@/components/SvgIcon/index.vue'
import { PlusOutlined, DownOutlined, UpOutlined, CopyOutlined } from '@ant-design/icons-vue'
const format = 'YYYY-MM-DD HH:mm:ss'
import ls from '@/utils/Storage'
const user = ls.get('USER_INFO')
import { fnExportFields } from './../customerFn'
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    },
    user_permission: {
        type: String,
        default: 'ludan'
    }
})
const emit = defineEmits(['cancel'])
const columns = [
    {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60
    },
    {
        title: '主体名称',
        dataIndex: 'full_name',
        key: 'full_name'
    },
    {
        title: '当前状态',
        dataIndex: 'exception_flag',
        key: 'exception_flag'
    },
    {
        title: '姓名电话',
        dataIndex: 'name',
        key: 'name'
    },
    {
        title: '到期时间',
        dataIndex: 'enter_endtime',
        key: 'enter_endtime'
    },
    {
        title: '注册地址',
        dataIndex: 'full_address',
        key: 'full_address'
    }
]
interface state {
    loading: boolean
    // 高级搜索 展开/关闭
    advanced: boolean
    platformList: any[]
    exportLoading: boolean
    cuikuanLoading: boolean
}
const state = reactive<state>({
    loading: false,
    advanced: true,
    platformList: [],
    exportLoading: false,
    cuikuanLoading: false
})
let queryParam = reactive<any>({
    remark: ''
})
let dataSource = ref([])
onMounted(() => {
    loadData()
    platformList()

    // 如果不是超级管理员或代理商，则导出的字段需要删除
    let exfild = fnExportFields(props.user_permission)
    exportDataArgumentChecked.exportDataArgument = exfild.all
    exportDataArgumentChecked.checkedfieldSimpleBak = exfild.jian
    exportDataArgumentChecked.checkedfieldAll = exfild.quan
    exportDataArgumentChecked.checkedfieldSimple = exfild.jian
})
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all' }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformList = res.data.list
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
const toggleAdvanced = () => {
    state.advanced = !state.advanced
}
// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (queryParam.between_time) {
        array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
const rangEnd = computed(() => {
    let array: any = []
    if (queryParam.between_end) {
        array = queryParam.between_end.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangEndChange = (val, str) => {
    if (val) {
        queryParam.between_end = str.join(',')
    } else {
        queryParam.between_end = null
    }
}
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/getallxflist',
        method: 'post',
        data: Object.assign({ customer_id: props.detailData.customer_id, xftel: props.detailData.xftel, type: 2 }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        dataSource.value = res.data.data
    })
}
const onFormSubmit = () => {
    emit('cancel')
}
//导出
const exportDataArgumentChecked = reactive({
    visible: false,
    companylist: '',
    exportDataArgument: [] as string[], //所有选项
    checkedfieldAll: [] as string[], //全能版
    checkedfieldSimpleBak: [] as string[], //精简版
    checkedfieldSimple: [] as string[] //已选中
})
const selectExportDataArgument = (type) => {
    if (type == 1) {
        exportDataArgumentChecked.checkedfieldSimple = exportDataArgumentChecked.checkedfieldSimpleBak
    } else if (type == 2) {
        exportDataArgumentChecked.checkedfieldSimple = exportDataArgumentChecked.checkedfieldAll
    } else {
        exportDataArgumentChecked.checkedfieldSimple = []
    }
}

const exportDatatab = ref('1')
const exportClick = (type) => {
    state.exportLoading = true
    exportDataArgumentChecked.visible = false
    queryParam.exportfield = exportDataArgumentChecked.checkedfieldSimple
    queryParam.type = type
    if (type == 2) {
        queryParam.companylist = exportDataArgumentChecked.companylist
    }
    let requestParam = {
        url: '/admin/v1/customerExport',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            responseType: 'blob'
        },
        data: Object.assign(
            {
                xftel: props.detailData.xftel,
                list_type: 'xf'
            },
            queryParam
        )
    }
    baseService(requestParam)
        .then((res) => {
            state.exportLoading = false
            message.success('下载成功')
        })
        .catch((res) => {
            state.exportLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('下载失败')
            }
        })
}
</script>
<style lang="less" scoped></style>
